var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 60 60" }, props),
    React.createElement(
      "circle",
      { fill: "grey", cx: "6", cy: "50", r: "6" },
      React.createElement("animate", { attributeName: "opacity", dur: "1s", values: "0;1;0", repeatCount: "indefinite", begin: ".1" })
    ),
    React.createElement(
      "circle",
      { fill: "grey", cx: "26", cy: "50", r: "6" },
      React.createElement("animate", { attributeName: "opacity", dur: "1s", values: "0;1;0", repeatCount: "indefinite", begin: ".2" })
    ),
    React.createElement(
      "circle",
      { fill: "grey", cx: "46", cy: "50", r: "6" },
      React.createElement("animate", { attributeName: "opacity", dur: "1s", values: "0;1;0", repeatCount: "indefinite", begin: ".3" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/assets/loading_dots.svg